import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Layout from "./components/layout/Layout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { AdminRouteGuard } from "./components/common/TenantGuard";
import Login from "./pages/hotels/Login";
import Register from "./pages/hotels/Register";
// for hotels
import Dashboard from "./pages/hotels/Dashboard";
import Demo from "./pages/hotels/Demo";
import DynamicPricing from "./pages/hotels/DynamicPricing";
import TripManagement from "./pages/hotels/TripManagement";
import Analytics from "./pages/hotels/Analytics";
import MarketAnalysis from "./pages/hotels/MarketAnalysis";
import PricingReview from "./pages/hotels/PricingReview";
import SystemPerformance from "./pages/hotels/SystemPerformance";
import Settings from "./pages/hotels/Settings";
import Support from "./pages/hotels/Support";
import Subscription from "./pages/hotels/Subscription";
import Invoices from "./pages/hotels/Invoices";
import PaymentSuccess from "./pages/hotels/PaymentSuccess";
import PaymentFailure from "./pages/hotels/PaymentFailure";

// Admin pages
import {
  AdminLayout,
  AdminDashboard,
  TenantList,
  TenantDetail,
  UserManagement,
  PlatformBilling,
  PlatformAnalytics,
  BillingConfiguration,
} from "./pages/admin";
import { hotelRoutesConfig } from "./HotelRoutes";
import { retailsRoutesConfig } from "./RetailRoutes";
import { useState } from "react";
import { useTheme } from "./context/ThemeContext";
import { restaurantsRoutesConfig } from "./RestaurantsRoutes";
import { ecommerceRoutesConfig } from "./EcommerceRoutes";

function App() {
  // "hotel" |"retail"|"restaurant"|"ecommerce"
  const { routeState } = useTheme();
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Admin routes (platform admins only) */}
        <Route
          path="/admin"
          element={
            // <ProtectedRoute>
              // <AdminRouteGuard>
                <AdminLayout />
              // </AdminRouteGuard>
            // </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="tenants" element={<TenantList />} />
          <Route path="tenants/:tenantId" element={<TenantDetail />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="billing" element={<PlatformBilling />} />
          <Route path="billing-config" element={<BillingConfiguration />} />
          <Route path="analytics" element={<PlatformAnalytics />} />
        </Route>

        {/* Client dashboard routes */}
        <Route
          path="/"
          element={
            // <ProtectedRoute>
              <Layout />
            // </ProtectedRoute>
          }
        >
          
          {routeState === "hotel"
            ? hotelRoutesConfig.map((route, index) => (
                <Route
                  key={index}
                  index={route.index}
                  path={route.path}
                  element={route.element}
                />
              ))
            : routeState === "retail"
              ? retailsRoutesConfig.map((route, index) => (
                  <Route
                    key={index}
                    index={route.index}
                    path={route.path}
                    element={route.element}
                  />
                ))
              : routeState === "restaurant"
                ? restaurantsRoutesConfig.map((route, index) => (
                    <Route
                      key={index}
                      index={route.index}
                      path={route.path}
                      element={route.element}
                    />
                  ))
                : ecommerceRoutesConfig.map((route, index) => (
                    <Route
                      key={index}
                      index={route.index}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
